import Banner from 'src/pages/Aboutus/components/Banner'
import Information from 'src/pages/Aboutus/components/Information'
import ValueProposition from 'src/pages/Aboutus/components/ValueContainer'
import Clients from 'src/pages/Aboutus/components/Clients'
import NewSection from 'src/pages/Aboutus/components/NewSection'
import Testimony from 'src/pages/Aboutus/components/Testimony'

const AboutPage = () => {
  return (
    <div style={{ backgroundColor: '#F4F4FC' }}>
      <Banner />
      <Information />
      <ValueProposition />
      <Clients></Clients>
      <NewSection />
    </div>
  )
}

export default AboutPage
